module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-95d1c21c.png";